import './sass/main.scss';

import 'lazysizes';
import 'objectFitPolyfill';
import 'picturefill';
import 'svgxuse';

import { ComponentHandler } from '@pixelart/component-handler';
import { Scrollmonitor } from '@pixelart/scrollmonitor';
import { Burgericon } from './components/burgericon/burgericon';
import { Contentlist } from './components/contentlist/contentlist';
import { cookieNotice } from './components/cookienotice/cookienotice';
import { Gallery } from './components/gallery/gallery';
import { HeaderSlider } from './components/headerslider/headerslider';
import { MainNav } from './components/mainnav/mainnav';
import { ParallaxContent } from './components/parallax-content/parallax-content';
import { Tracking } from './components/tracking/tracking';
import { images } from './modules/images';

import './components/animations/animations';
import './components/cookiebot/cookiebot';
import './components/download/download';
import './components/footer_contact/footer_contact';
import './components/footerbar/footerbar';
import './components/header/header';
import './components/headline/headline';
import './components/listitem/listitem';
import './components/map/map';
import './components/px-icon/px-icon';
import './components/text_image/text_image';
import './components/tiles/tiles';
import './js/modules/adaptive-img.js';
import './js/polyfills/object_assign.js';

cookieNotice();
images();

const scrollMonitor = new Scrollmonitor();
scrollMonitor.init();

const parallaxContent = new ParallaxContent();
parallaxContent.init();

const componentHandler = new ComponentHandler();
componentHandler.addComponent(Gallery, '.gallery');
componentHandler.addComponent(Contentlist, '.contentlist');
componentHandler.addComponent(HeaderSlider, '.headerslider');
componentHandler.addComponent(Burgericon, '.burgericon');
componentHandler.addComponent(MainNav, '.mainnav');
componentHandler.addComponent(Tracking, '.tracking');



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./assets/app.ts